import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConsentimientoService } from '../../services/module-config/consentimiento/consentimiento.service';
import { AuthService } from '../../services/auth.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CargosService } from '../../services/module-config/cargos/cargos.service';
import * as htmlToImage from 'html-to-image';
// import confetti from 'canvas-confetti';
import Swal from 'sweetalert2';
import { PrivacyPolicyService } from 'app/services/module-config/privacy-policies/privacy-policie.service';
@Component({
  selector: 'app-home',
  standalone: false,
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit, OnDestroy {
  mostrarModalConsentimiento = false;
  checkboxAceptado = false;
  usuarioId!: number;
  perfilCompleto: boolean | string = false;

  ipCliente: string = '';
  pdfUrl: string = '';
  versionPolitica: string = '';

  mostrarModalFirma = false;

  firma = {
    nombre: '',
    cargo: '',
    area: '',
    telefono: '',
    correo: '',
  };

  firmaHtml!: SafeHtml;
  firmaHtmlString: string = '';
  modoEdicionFirma = false;
  claveFirma = '';
  claveCorrecta = 'editarfirma';
  copiandoFirma = false;
  mensajeFirma = '';

  modalIframeDocumento = false;
  urlTemporalIframe: string | null = null;
  tituloIframeDocumento = 'Política de privacidad';
  nombreDescargaIframeDocumento = 'Politica_de_Privacidad.pdf';
  maximizarIframeDocumento = false;

  cargandoPoliticaPrivacidad = false;
  show = false;
  private privacyPdfObjectUrl: string | null = null;

  constructor(
    private http: HttpClient,
    private consentimientoService: ConsentimientoService,
    private authService: AuthService,
    private sanitizer: DomSanitizer,
    private cargosService: CargosService,
    private privacyPolicyService: PrivacyPolicyService,
  ) { }

  ngOnInit(): void {
    const usuario = this.authService.getUsuarioDesdeToken();

    if (usuario) {
      this.usuarioId = usuario.id;
      this.cargarFirmaDesdeBackend();
      this.perfilCompleto = String(usuario.perfil_completo) === 'true';
      this.showBirthdayEffectIfNeeded(usuario);
    } else {
      console.error('    No se pudo obtener el usuario desde el token');
      return;
    }

    this.generarFirma();
  }
  ngOnDestroy(): void {
    this.revokePrivacyPdfUrl();
  }
  abrirFirma() {
    this.mostrarModalFirma = true;
  }

  cerrarFirma() {
    this.mostrarModalFirma = false;
    const hola = './../../../assets/img/NOVAXLOGO.png';
  }

  generarFirma() {
    const html = `
<table cellpadding="0" cellspacing="0" style="font-family: Arial, sans-serif; color:#000; width:560px;">
  <tr>

    <!-- LOGO -->
    <td style="width:260px; vertical-align:middle; text-align:center;">
      <img src="./../../../assets/img/NOVAXLOGO.png" width="300" style="display:block; margin:auto;">
    </td>

    <!-- LINEA ROJA VERTICAL -->
<td width="3" style="padding:0; font-size:0; line-height:0; vertical-align:top;">
  <table cellpadding="0" cellspacing="0" width="3" style="width:3px;">
    <tr>
      <td height="5" style="font-size:0; line-height:0;">&nbsp;</td>
    </tr>
    <tr>
      <td height="170" bgcolor="#e10600"
          style="background:#e10600; font-size:0; line-height:0;">
        &nbsp;
      </td>
    </tr>
    <tr>
      <td style="font-size:0; line-height:0;">&nbsp;</td>
    </tr>
  </table>
</td>

    <!-- CONTENIDO -->
    <td style="padding-left:18px; vertical-align:middle; width:317px;">

      <div style="text-align:center;">

        <div style="font-size:22px; font-weight:900; text-transform:uppercase; letter-spacing:0.4px;">
          ${this.firma.nombre || 'Porfavor completa tu perfil'}
        </div>

        <div style="font-size:13px; margin-top:4px; text-transform:uppercase; line-height:1.3;">
          ${this.firma.cargo || 'Indicar a TTHH sin cargo'}
        </div>

        <table width="80%" cellpadding="0" cellspacing="0" style="margin:10px auto;">
          <tr>
            <td height="2" bgcolor="#e10600" style="background:#e10600; font-size:0; line-height:0;">&nbsp;</td>
          </tr>
        </table>

      </div>

      <!-- DATOS -->
      <table cellpadding="0" cellspacing="0" style="font-size:13px; line-height:1.5; margin-top:4px;">

        <tr>
          <td style="padding-right:8px;">
            <img src="./../../../assets/social/blacks/llamada-telefonica.png" width="17">
          </td>
          <td>${this.firma.telefono || 'Completar su perfil'}</td>
        </tr>


        <tr>
          <td style="padding-right:8px;">
            <img src="./../../../assets/social/blacks/correo-electronico.png" width="17">
          </td>
          <td>${this.firma.correo || 'Completar su perfil'}</td>
        </tr>

        <tr>
          <td style="padding-right:8px;">
            <img src="./../../../assets/social/blacks/ubicacion.jpg" width="15">
          </td>
          <td>29 de enero entre Jorge Mosquera y Zamora, Yantzaza</td>
        </tr>

        <tr>
          <td style="padding-right:8px;">
            <img src="./../../../assets/social/blacks/web.png" width="17">
          </td>
          <td>www.novax.ec</td>
        </tr>

      </table>

      <!-- REDES -->
      <div style="margin-top:12px; text-align:center;">
        <span style="display:inline-block; margin-right:8px;">
          <img src="./../../../assets/social/blacks/linkedin.png" width="20">
        </span>
        <span style="display:inline-block; margin-right:8px;">
          <img src="./../../../assets/social/blacks/logotipo-de-instagram.png" width="20">
        </span>
        <span style="display:inline-block;">
          <img src="./../../../assets/social/blacks/facebook.png" width="20">
        </span>
      </div>

    </td>
  </tr>

  <!-- LINEA ROJA INFERIOR (SEPARADA PARA QUE NO TOQUE LA VERTICAL) -->
<!-- LINEA ROJA INFERIOR -->
<tr>
  <!-- Rojo izquierda -->
  <td height="10" bgcolor="#e10600"
      style="background:#e10600; font-size:0; line-height:0;">
    &nbsp;
  </td>

  <!-- Hueco bajo la línea vertical -->
  <td width="3" style="background:#e10600; font-size:0; line-height:0;">
    &nbsp;
  </td>

  <!-- Rojo derecha -->
  <td height="10" bgcolor="#e10600"
      style="background:#e10600; font-size:0; line-height:0;">
    &nbsp;
  </td>
</tr>

</table>
  `;

    this.firmaHtmlString = html;
    this.firmaHtml = this.sanitizer.bypassSecurityTrustHtml(html);
  }

  // async copiarFirma() {
  //   try {
  //     const blob = new Blob([this.firmaHtmlString], { type: 'text/html' });
  //     const data = [new ClipboardItem({ 'text/html': blob })];

  //     await navigator.clipboard.write(data);

  //     console.log('Firma copiada correctamente');
  //   } catch (err) {
  //     console.error('Error copiando firma:', err);
  //   }
  // }

  cargarFirmaDesdeBackend() {
    this.cargosService.obtenerFirmaUsuario(this.usuarioId).subscribe({
      next: (data) => {
        this.firma.nombre = this.formatearNombre(data.nombres, data.apellidos);
        this.firma.cargo = data.cargo?.toUpperCase() || '';
        this.firma.telefono = data.telefono || '';
        this.firma.correo = data.correo || '';

        this.generarFirma(); // 🔥 clave
      },
      error: (err) => {
        console.error('Error cargando firma:', err);
      },
    });
  }

  formatearNombre(nombres: string, apellidos: string): string {
    if (!nombres || !apellidos) return '';

    const conectores = [
      'de',
      'del',
      'la',
      'las',
      'los',
      'y',
      'van',
      'von',
      'der',
      'den',
      'da',
      'dos',
      'das',
      'do',
      'di',
      'le',
      'du',
    ];

    const nombresArr = nombres.trim().toLowerCase().split(/\s+/);
    const apellidosArr = apellidos.trim().toLowerCase().split(/\s+/);

    const primerNombre = nombresArr[0];

    // 🔹 reconstruir apellidos dinámicamente
    let apellidosReconstruidos: string[] = [];
    let actual = '';

    for (let i = 0; i < apellidosArr.length; i++) {
      const palabra = apellidosArr[i];

      // si es conector → se une al siguiente
      if (conectores.includes(palabra)) {
        actual += (actual ? ' ' : '') + palabra;
        continue;
      }

      // si hay algo acumulado → formar apellido compuesto
      if (actual) {
        actual += ' ' + palabra;
        apellidosReconstruidos.push(actual);
        actual = '';
      } else {
        apellidosReconstruidos.push(palabra);
      }
    }

    // 🔹 tomar apellidos
    const primerApellido = apellidosReconstruidos[0] || '';
    const segundoApellido = apellidosReconstruidos[1] || '';

    // 🔹 limpiar conectores para inicial
    const limpiar = (txt: string) =>
      txt.replace(
        /^(de|del|la|las|los|y|van|von|der|den|da|dos|das|do|di|le|du)\s+/i,
        '',
      );

    const inicialSegundoApellido = segundoApellido
      ? limpiar(segundoApellido).charAt(0) + '.'
      : '';

    return `${primerNombre} ${primerApellido} ${inicialSegundoApellido}`
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();
  }
  validarClaveFirma() {
    if (this.claveFirma === this.claveCorrecta) {
      this.modoEdicionFirma = true;
    } else {
      alert('Clave incorrecta');
    }
  }

  async copiarFirma() {
    const elemento = document.getElementById('firma-captura') as HTMLElement;
    if (!elemento) return;

    try {
      this.copiandoFirma = true;
      this.mensajeFirma = '';
      elemento.style.padding = '0';
      elemento.style.margin = '0';
      elemento.style.border = 'none';
      elemento.style.boxShadow = 'none';

      const anchoOriginal = elemento.scrollWidth; // 552
      const altoOriginal = elemento.scrollHeight; // 261

      const escala = 0.20; // 10% más pequeño
      // const escala = 0.85; // 15% más pequeño

      const blob = await htmlToImage.toBlob(elemento, {
        width: Math.round(anchoOriginal * escala),
        height: Math.round(altoOriginal * escala),
        style: {
          transform: `scale(${escala})`,
          transformOrigin: 'top left',
          width: `${anchoOriginal}px`,
          height: `${altoOriginal}px`,
          overflow: 'visible',
        },
        pixelRatio: 5,
        backgroundColor: '#ffffff',
      });
      if (!blob) return;

      const item = new ClipboardItem({
        'image/png': blob,
      });

      await navigator.clipboard.write([item]);

      this.mensajeFirma =
        '✔ Firma copiada correctamente. Ya puede pegarla en Outlook con Ctrl + V o clic derecho → Pegar.';

      console.log('Firma recortada derecha correctamente');
    } catch (error) {
      console.error('Error copiando firma:', error);
      this.copiandoFirma = false;
      this.mensajeFirma = '❌ Error al copiar la firma';
    } finally {
      this.copiandoFirma = false;
      setTimeout(() => {
        this.mensajeFirma = '';
      }, 5000);
    }
  }

  // enviar a otra ruta
  irAFatiga() {
    location.href = '/fatigue/user';
  }

  irARegistrarUso() {
    location.href = '/mantenimientos/mantenimientos-km-hr/mantenimientos-km-hr-formulario';
  }
  abrirSoporteWhatsApp(): void {
    window.open(
      'https://wa.me/593986343538?text=Hola%20equipo%20SOPORTE%20IT%20NOVAX%2C%20requiero%20ayuda%20con%20un%20tema.%20%C2%BFMe%20apoyan%3F',
      '_blank',
      'noopener,noreferrer',
    );
  }

  async copiarLinkActualizacionContacto(): Promise<void> {
    const link = `${window.location.origin}/public/update-contact-info`;

    try {
      await navigator.clipboard.writeText(link);
      alert('Link copiado correctamente.');
    } catch (error) {
      console.error('Error copiando link:', error);

      const input = document.createElement('input');
      input.value = link;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);

      alert('Link copiado correctamente.');
    }
  }
  private showBirthdayEffectIfNeeded(user: any): void {
    const raw = sessionStorage.getItem('showBirthdayBalloons');
    if (!raw) return;

    sessionStorage.removeItem('showBirthdayBalloons');

    let data: any = null;

    try {
      data = JSON.parse(raw);
    } catch {
      return;
    }

    if (!data?.show) return;

    const name = `${user?.nombre ?? ''} ${user?.apellidos ?? ''}`
      .trim()
      .toUpperCase();

    Swal.fire({
      width: 390,
      padding: 0,
      background: '#ffffff',
      showConfirmButton: true,
      confirmButtonText: 'Gracias',
      confirmButtonColor: '#2563eb',
      timer: 9000,
      timerProgressBar: true,
      customClass: {
        popup: 'erp-birthday-popup',
        confirmButton: 'erp-birthday-button',
      },
      html: `
      <div style="
        box-sizing:border-box;
        width:100%;
        padding:20px 22px 18px;
        text-align:center;
        border-top:4px solid #2563eb;
        font-family:Arial, sans-serif;
      ">

        <div style="
          display:flex;
          justify-content:center;
          align-items:center;
          gap:14px;
          margin-bottom:14px;
        ">
          <img
            src="assets/img/NOVAXLOGO.png"
            alt="NOVAX"
            style="
              width:96px;
              height:auto;
              max-height:32px;
              object-fit:contain;
              display:block;
            "
          />

          <div style="
            width:1px;
            height:28px;
            background:#cbd5e1;
          "></div>

          <img
            src="assets/img/Zivo_only_logo.png"
            alt="ZIVO"
            style="
              width:42px;
              height:42px;
              object-fit:contain;
              display:block;
            "
          />
        </div>

        <div style="
          font-size:10px;
          font-weight:700;
          letter-spacing:1.4px;
          color:#64748b;
          margin-bottom:8px;
        ">
          NOVAX · ZIVO ERP
        </div>

        <div style="
          font-size:17px;
          font-weight:700;
          color:#0f172a;
          line-height:1.3;
          margin-bottom:10px;
        ">
          Feliz cumpleaños${name ? `, ${name}` : ''}
        </div>

        <div style="
          font-size:13px;
          line-height:1.45;
          color:#475569;
          max-width:310px;
          margin:0 auto;
        ">
          El equipo <strong style="color:#1d4ed8;">NOVAX-ZIVO</strong>
          te desea un excelente día, lleno de éxitos, bienestar y nuevas metas cumplidas.
        </div>

        <div style="
          height:1px;
          background:#e2e8f0;
          margin:15px 0 10px;
        "></div>

        <div style="
          font-size:12px;
          color:#64748b;
        ">
          Gracias por ser parte de nuestro equipo.
        </div>
      </div>
    `,
    });
  }
  abrirPoliticaPrivacidad(event?: Event): void {
    event?.preventDefault();

    if (this.cargandoPoliticaPrivacidad) {
      return;
    }

    this.cargandoPoliticaPrivacidad = true;

    this.revokePrivacyPdfUrl();

    this.privacyPolicyService.viewCurrent('employee', 'PRIVACY_POLICY').subscribe({
      next: (blob) => {
        const pdfBlob = new Blob([blob], {
          type: 'application/pdf',
        });

        this.privacyPdfObjectUrl = URL.createObjectURL(pdfBlob);

        this.urlTemporalIframe =
          `${this.privacyPdfObjectUrl}#toolbar=0&navpanes=0&scrollbar=1`;

        this.tituloIframeDocumento = 'Política de privacidad';
        this.nombreDescargaIframeDocumento = 'Politica_de_Privacidad.pdf';

        this.maximizarIframeDocumento = false;
        this.modalIframeDocumento = true;
        this.cargandoPoliticaPrivacidad = false;
      },

      error: async (error) => {
        console.error(
          'Error cargando la política de privacidad:',
          error,
        );

        this.cargandoPoliticaPrivacidad = false;

        const mensaje = await this.getBlobErrorMessage(error);

        Swal.fire({
          icon: 'error',
          title: 'No se pudo cargar el documento',
          text: mensaje,
          confirmButtonText: 'Aceptar',
        });
      },
    });
  }
  cerrarIframeDocumento(): void {
    this.modalIframeDocumento = false;
    this.urlTemporalIframe = null;
    this.maximizarIframeDocumento = false;

    this.revokePrivacyPdfUrl();
  }

  toggleMaximizarIframe(): void {
    this.maximizarIframeDocumento =
      !this.maximizarIframeDocumento;
  }
  private revokePrivacyPdfUrl(): void {
    if (!this.privacyPdfObjectUrl) {
      return;
    }

    URL.revokeObjectURL(this.privacyPdfObjectUrl);
    this.privacyPdfObjectUrl = null;
  }
  private async getBlobErrorMessage(error: any): Promise<string> {
    if (error?.error instanceof Blob) {
      const text = await error.error.text();

      try {
        const parsed = JSON.parse(text);

        return (
          parsed?.message ||
          parsed?.error ||
          text
        );
      } catch {
        return (
          text ||
          'No se pudo cargar la política de privacidad.'
        );
      }
    }

    return (
      error?.error?.message ||
      error?.error?.error ||
      'No se pudo cargar la política de privacidad.'
    );
  }
}
